export default __webpack_public_path__ + "static/media/htu-f2.3ebf8dab.png";